var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide-pages"},[_c('div',{staticClass:"guide-pages__lazy"},_vm._l((_vm.imageList),function(url){return _c('el-image',{key:url,attrs:{"src":url,"lazy":""}},[_c('div',{staticClass:"image-slot",attrs:{"slot":"error"},slot:"error"},[_c('i',{staticClass:"el-icon-picture-outline"})])])}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }